import isEmpty from 'lodash/isEmpty';
import React from 'react';

import UsersGroup from '@decisiv/iconix/lib/components/UsersGroup';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import { H1 } from '@decisiv/ui-components/lib/components/Typography';

import { t } from '@lingui/macro';

import EmptyResults from 'components/EmptyResults';
import Loading from 'components/Loading';
import PageHead from 'components/PageHead';

import { useTeams } from './contexts/TeamsContext';
import TeamsList from './TeamsList';
import CreateTeamModal from './CreateTeamModal';
import TeamModalProvider from './CreateTeamModal/contexts/TeamModalContext';

export default function TeamsPage() {
  const {
    loading,
    allSentinelTeams,
    pagination,
    onSort,
    defaultSort,
    setPage,
  } = useTeams();

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <PageHead titleParts={[t`Teams`, t`Decisiv Super Admin`]} />

      <Flex>
        <Flex flex={1} paddingX={2} paddingY={1}>
          <Flex flex={1} alignItems="center" justifyContent="space-between">
            <H1 weight="regular">{t`Teams`}</H1>
            <TeamModalProvider>
              <CreateTeamModal />
            </TeamModalProvider>
          </Flex>
        </Flex>
      </Flex>
      <Flex flexDirection="column" style={{ overflow: 'hidden' }}>
        {isEmpty(allSentinelTeams) ? (
          <EmptyResults
            color="licoriceMousse"
            icon={UsersGroup}
            subtitle={t`Click CREATE TEAM to start creating a team.`}
            title={t`No Teams Yet`}
          />
        ) : (
          <TeamsList
            teams={allSentinelTeams}
            onSort={onSort}
            setPage={setPage}
            pagination={pagination}
            defaultSort={defaultSort}
          />
        )}
      </Flex>
    </>
  );
}
